export default {
  blogContent: {
    title1: "MAHAL",
    title2: "المقالات",

    desc:
      "قصص ورؤى وتحديثات من نظام توريد الأغذية بين الشركات.",

    readMore: "اقرأ المقال",

    blogs: [
      {
        category: "رؤى الصناعة",
        title: "كيف يمكن للمطاعم تحسين عمليات الشراء اليومية",
      },
      {
        category: "سلسلة التوريد",
        title: "بناء شبكات موردين موثوقة في مجال الأغذية",
      },
      {
        category: "العمليات",
        title: "تقليل التكاليف دون التأثير على الجودة",
      },
      {
        category: "السوق",
        title: "لماذا الأسواق الرقمية هي مستقبل توريد الغذاء",
      },
      {
        category: "المطاعم",
        title: "الطلب اليومي أم بالجملة: ما الأفضل؟",
      },
      {
        category: "الموردون",
        title: "كيف يمكن للموردين النمو بشكل أسرع باستخدام MAHAL",
      },
      {
        category: "اللوجستيات",
        title: "ضمان التسليم في الوقت المحدد للطلبات الكبيرة",
      },
      {
        category: "التكنولوجيا",
        title: "كيف تحسن البيانات الشفافية في الشراء",
      },
      {
        category: "النمو",
        title: "شراكات طويلة الأمد بين المطاعم والموردين",
      },
    ],
  },
};